import { useState } from "react";
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { ListItemIcon, MenuItem, SvgIcon } from "@mui/material";
import { useTranslation } from "react-i18next";

interface OptionsButton {
    Icon: React.ElementType;
    text: string;
    onClick: () => void;
}

interface PropsRedirection {
    options: OptionsButton[];
}

const GeneralInformationRedirection = ({ options }: PropsRedirection) => {
    const { t } = useTranslation();
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    if (!options || options.length === 0) {
        return <></>;
    }

    return (
        <div>
            <Button
                id="action-button"
                aria-controls={open ? 'action-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}
                variant="contained"
                endIcon={<KeyboardArrowDownIcon />}
            >
                {t("shop.otherAction")}
            </Button>
            <Menu
                id="action-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'action-button',
                    sx: { paddingBottom: 0 }
                }}
            >
                {
                    options.map((option) => (
                        <MenuItem onClick={option.onClick} key={option.text} divider>
                            <>
                                <ListItemIcon children={<SvgIcon component={option.Icon} inheritViewBox />} />
                                {option.text}
                            </>
                        </MenuItem>
                    ))
                }
            </Menu>
        </div>
    );
};

export default GeneralInformationRedirection;
